import React, { useState } from 'react'
import { prependBackendUrl } from '../gql/client'

interface UserAvatarProps {
  user: {
    firstName: string
    lastName: string
    avatar?: string | null
  } | null
  size?: number
  className?: string
  tooltipId?: string
}

export const UserAvatar: React.FC<UserAvatarProps> = ({
  user,
  size = 35,
  className = '',
  tooltipId
}) => {
  const [imageError, setImageError] = useState(false)

  // Si no hay usuario, mostrar placeholder
  if (!user) {
    return (
      <span
        className={`initial-names-rounded ${className}`}
        data-tooltip-id={tooltipId}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: size,
          height: size,
          borderRadius: '50%',
          backgroundColor: '#e4e6ef',
          color: '#7e8299',
          fontWeight: 600,
          fontSize: size * 0.4,
          cursor: 'pointer',
          border: '2px solid #e4e6ef',
        }}
      >
        N/A
      </span>
    )
  }

  // Si hay avatar y no ha fallado, mostrar la imagen
  if (user.avatar && !imageError) {
    return (
      <img
        src={prependBackendUrl(user.avatar)}
        alt={`${user.firstName} ${user.lastName}`}
        className={`avatar-rounded ${className}`}
        data-tooltip-id={tooltipId}
        style={{
          width: size,
          height: size,
          objectFit: 'cover',
          borderRadius: '50%',
          border: '2px solid #e4e6ef',
          cursor: 'pointer',
        }}
        onError={() => {
          // Si la imagen falla al cargar, mostrar iniciales
          setImageError(true)
        }}
      />
    )
  }

  // Fallback: mostrar iniciales
  const initials = `${user.firstName?.[0] || ''}${user.lastName?.[0] || ''}`

  return (
    <span
      className={`initial-names-rounded ${className}`}
      data-tooltip-id={tooltipId}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: '#009ef7',
        color: '#fff',
        fontWeight: 600,
        fontSize: size * 0.4,
        cursor: 'pointer',
        border: '2px solid #e4e6ef',
      }}
    >
      {initials}
    </span>
  )
}
